/**
 * The phone tab bar's destinations. Since the redesign (Anthony, 2026-10-13: "On
 * phones, the same five items become a bottom tab bar") they ARE the sidebar's five
 * items, read from NAV_ITEMS, so the two cannot drift. The Phase 3 tabs (Home,
 * Budget, Transactions, Forecast, More) are retired with it: every page More listed is
 * now a section tab under one of the five (Budgets, Goals and Debt under Plan; Rules
 * under Activity; Bills & income under Upcoming; Review my data under Insights), and
 * the account pages are in the header's account menu, which shows at phone width.
 * Data only, so it can be tested and the component file exports components alone.
 */
import type { LucideIcon } from "lucide-react";
import { REDESIGN_NAV_ITEMS } from "@/config/redesignNavItems";

interface Tab {
  to: string;
  label: string;
  icon: LucideIcon;
  /** Paths that light this tab (the first is `to`). */
  lights: string[];
}

export const REDESIGN_PHONE_TABS: Tab[] = REDESIGN_NAV_ITEMS.map((item) => ({
  to: item.to,
  label: item.label,
  icon: item.icon,
  lights: [...item.sections.map((s) => s.to), ...(item.alsoLights ?? [])],
}));

export function redesignLit(pathname: string, paths: string[]): boolean {
  return paths.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}
